import { Form } from 'factorial-form'
import _ from 'lodash'

export type ValueType = 'date' | 'string'

class ArgumentForm extends Form {
  static buildForms(args: any[], valueTypes: ValueType[]): ArgumentForm[] {
    return args.map((argument, index: number) => {
      return new ArgumentForm(
        {
          value: argument.value,
          use_variable: argument.use_variable,
        },
        valueTypes[index]
      )
    })
  }

  constructor(values: Record<string, any>, valueType: ValueType = 'string') {
    super(values, {
      value: valueType,
      use_variable: 'boolean',
    })
  }

  static convertToParams(forms: ArgumentForm[]): any[] {
    return _(forms)
      .map((form: ArgumentForm) => ({
        value: form.getValue(),
        use_variable: form.getUseVariable(),
      }))
      .value()
  }

  getValue(): string | null | undefined {
    const data = this.data()
    const value = data.value

    if (_.isEmpty(value)) return null

    return value
  }

  getUseVariable(): boolean {
    const data = this.data()

    return !!data.use_variable
  }
}

export default ArgumentForm
